<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p58"><span><a href="#/Contents#rp58">FRESH TOMATO SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>To peel tomatoes, place a few at a time into a pan of boiling water for about 30 seconds. Remove and slip off skins. Halve the tomatoes and remove seeds.</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>4 each: sliced green onions, minced cloves garlic</span></p>
<p class="hang"><span>1 teaspoon olive oil</span></p>
<p class="hang"><span>2½ pounds tomatoes, peeled, seeded, chopped, divided</span></p>
<p class="hang"><span>2½ cups Rich Chicken Stock (see <a href="#/Chapter014#p4">p. 4</a>)</span></p>
<p class="hang"><span>¼ cup chopped fresh or 1 tablespoon dried basil leaves</span></p>
<p class="hang"><span>1 bay leaf</span></p>
<p class="hang"><span>2 teaspoons sugar</span></p>
<p class="hang"><span>½ cup dry white wine (optional)</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="hang"><span>Chopped parsley, as garnish</span></p>
<p class="normalt"><span><b>1.</b> Sauté green onions and garlic in oil in large saucepan until transparent, about 2 minutes. Reserve 2 cups tomatoes; process remaining tomatoes in food processor or blender until smooth; stir into saucepan and cook 5 minutes. Stir in stock, basil, bay leaf, and sugar. Heat to boiling; reduce heat and simmer, uncovered, 40 minutes, adding wine and reserved 2 cups tomatoes during last 15 minutes. Discard bay leaf; season to taste with salt and pepper. Garnish each bowl of soup with parsley.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 87</span></p>
<p class="per1"><span>% calories from fat: 17</span></p>
<p class="per1"><span>Protein (g): 4</span></p>
<p class="per1"><span>Carbohydrate (g): 11.6</span></p>
<p class="per1"><span>Fat (g): 1.8</span></p>
<p class="per1"><span>Saturated fat (g): 0.3</span></p>
<p class="per1"><span>Cholesterol (mg): 0.4</span></p>
<p class="per1"><span>Sodium (mg): 36</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 2.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.5</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0239.vue?6a9f6eec